export default "__VITE_ASSET__d4fd3c19__"